export default "__VITE_ASSET__4YePQlCE__"